import explodingBomb from '@/assets/images/pdp/hazard/ghs01_exploding_bomb.png';
import flame from '@/assets/images/pdp/hazard/ghs02_flame.png';
import flameOverCircle from '@/assets/images/pdp/hazard/ghs03_flame_over_circle.png';
import gasCylinder from '@/assets/images/pdp/hazard/ghs04_gas_cylinder.png';
import corrosion from '@/assets/images/pdp/hazard/ghs05_corrosion.png';
import skullAndCrossbones from '@/assets/images/pdp/hazard/ghs06_skull_and_crossbones.png';
import exclamationMark from '@/assets/images/pdp/hazard/ghs07_exclamation_mark.png';
import healthHazard from '@/assets/images/pdp/hazard/ghs08_health_hazard.png';
import environment from '@/assets/images/pdp/hazard/ghs09_environment.png';
export const hazardSymbolMapping = {
  'Approved pictograms/GHS01_Exclamation Mark.png': explodingBomb,
  'Approved pictograms/GHS02_Flame.png': flame,
  'Approved pictograms/GHS03_Flame Over Circle.png': flameOverCircle,
  'Approved pictograms/GHS04_Gas Cylinder.png': gasCylinder,
  'Approved pictograms/GHS05_Corrosion.png': corrosion,
  'Approved pictograms/GHS06_Skull and Crossbones.png': skullAndCrossbones,
  'Approved pictograms/GHS07_Exclamation Mark.png': exclamationMark,
  'Approved pictograms/GHS08_Health Hazard.png': healthHazard,
  'Approved pictograms/GHS09_Environment.png': environment,
};
